export default function EFTv(props: any) {
    return (
        <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="50''TV_icon">
                    <rect id="矩形" x="0" y="0" width="30" height="30"></rect>
                    <g id="编组-66" transform="translate(1.559808, 4.722207)" stroke={props.color || '#FFFFFF'}>
                        <polyline
                            id="路径"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            points="17.0759529 19.7649874 17.0759529 17.393189 9.96055745 17.393189 9.96055745 19.7649874"
                        ></polyline>
                        <path
                            d="M1.41484215,0 L25.4655407,0 C26.2469802,0 26.8803829,0.648934646 26.8803829,1.44953601 L26.8803829,16.1500191 C26.8803829,16.8366632 26.3371774,17.393189 25.6669677,17.393189 L1.41484215,17.393189 C0.633402745,17.393189 0,16.7442543 0,15.9436529 L0,1.44953601 C0,0.648934646 0.633402745,0 1.41484215,0 Z"
                            id="Stroke-301"
                        ></path>
                        <line
                            x1="6.17019876"
                            y1="20.1602872"
                            x2="20.4009897"
                            y2="20.1602872"
                            id="Stroke-302"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}
